var React = require('react');

function IconB3PlayerPause (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"opacity":"0.8","fill":"#FFFFFF","cx":"16","cy":"15.999","r":"16","key":0}),React.createElement("g",{"key":1},[React.createElement("path",{"fill":"#3C3C3B","d":"M14.249,9.895H11.23c-0.297,0-0.538,0.24-0.538,0.536v11.136c0,0.298,0.241,0.537,0.538,0.537h3.019\n\t\t\tc0.297,0,0.534-0.239,0.534-0.537V10.431C14.783,10.135,14.546,9.895,14.249,9.895z","key":0}),React.createElement("path",{"fill":"#3C3C3B","d":"M20.769,9.895H17.75c-0.297,0-0.534,0.24-0.534,0.536v11.136c0,0.298,0.237,0.537,0.534,0.537h3.019\n\t\t\tc0.297,0,0.538-0.239,0.538-0.537V10.431C21.307,10.135,21.066,9.895,20.769,9.895z","key":1})])]));
}

IconB3PlayerPause.displayName = "IconB3PlayerPause";

IconB3PlayerPause.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = IconB3PlayerPause;

IconB3PlayerPause.default = IconB3PlayerPause;
